import SelectTypeFormContainer from './select_type_form_container';

const SelectTypeForm = SelectTypeFormContainer;
export default SelectTypeForm;
